<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div [ngClass]="{selected: tab?.selected}" id='topTab{{tab?.id}}' tabindex="{{indexOfTab + 1}}" (click)='selectTab(tab);' (keydown.space)='$event.preventDefault();' (keyup.space)='selectTab(tab);' draggable="true" (keydown.spacebar)='$event.preventDefault();'
    (keyup.spacebar)='selectTab(tab);' (dragstart)="tabDragStart($event, this,tab)" (focus)='focusOutEvent(tab);' (dragend)="tabDragEnd(tab, $event)">
    <div class="lms-tab">
        <span class="tab-text" title="{{tab?.description}}">{{tab?.description}}
        </span>
        <i class="fa fa-times" title="Close Tab" tabindex="{{indexOfTab + 2}}" (click)='removeTab(tab);' (keydown.spacebar)='$event.preventDefault();' (keyup.spacebar)='removeTab(tab);' (keydown.space)='$event.preventDefault();' (keyup.space)='removeTab(tab);'
            aria-hidden="true" (focus)='focusOutEvent(tab);'></i>
    </div>
</div>

<p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="false" class="terminal-ui-popups standard-dialog" header="Information" [(visible)]="showWarnPop" modal="true" (onHide)='hidePopup();' (onShow)='setPageMode("goForPopoutOptnBtn");'>
    <div class="generic-spacing">
        {{warnMessage}}
    </div>

    <div class="dialog-buttons">

        <span class="pull-right">
					<button class="p-button-secondary" tabindex="{{tabLevelDialog - 10}}" (click)="hidePopup();">Cancel</button>
					<button class="p-button-primary" tabindex="{{tabLevelDialog - 9}}" id="goForPopoutOptnBtn" (click)="goForPopoutOps()">OK</button>
			</span>

    </div>
</p-dialog>


<p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="false" class="terminal-ui-popups standard-dialog" header="Confirmation" (onHide)='hidePopup();' [(visible)]="showDeletePop" modal="true" (onShow)='setPageMode("removeTabYsBtn");'>
    <div class="generic-spacing">
        {{deleteWarnMessage}}
    </div>

    <div class="dialog-buttons">

        <span class="pull-right">
				<button class="p-button-secondary" tabindex="{{tabLevelDialog - 8}}" (click)="hidePopup()">No</button>
					<button class="p-button-primary" tabindex="{{tabLevelDialog - 7}}" id="removeTabYsBtn" (click)="removeTab(tab,true)">Yes</button>
			</span>

    </div>
</p-dialog>